import styled from 'styled-components'
import colors, { TColor } from '../../tokens/colors'
import fonts from '../../tokens/fonts'

export const IconWrapper = styled.div<{
  size: number
  color?: TColor
  cursor: string
}>`
  color: ${(props) => `${colors[props.color]} !important` || 'inherit'};
  display: flex;
  font-size: inherit;
  line-height: normal;
  height: ${(props) => (props.size - 2) / 10}rem;
  width: ${(props) => (props.size - 2) / 10}rem;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => props.cursor};

  svg {
    font-size: ${(props) => props.size / 10}rem;
    height: ${(props) => props.size / 10}rem;
    width: ${(props) => props.size / 10}rem;
  }
`

interface Props {
  color?: TColor
  name: string
  size?: number
}

export const CharIcon = styled.div<Props>`
  font-family: ${fonts.inter};
  color: ${(props) => colors[props.color] || 'inherit'};
  font-size: ${(props) => (props.size - 4) / 10}rem;
  padding: 0.2rem;
`
export const SvgContainer = styled.div<Props>`
  display: flex;
  svg {
    fill: ${(props) => colors[props.color] || 'inherit'};
  }
`
